import { styled } from '@mui/material';
import BackgroundImage from '@assets/images/main-bg.jpg';

export const Styles = {
  FirstSection: styled('section')<{ gridDirection?: 'column' | 'row' }>(
    ({ theme, gridDirection }) => ({
      display: 'flex',
      padding: '0 0px',
      paddingTop: gridDirection === 'row' ? '20px' : '0px',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '1200px',
      margin: 'auto',
      width: '100%',
      gap: '10px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        gap: '3px',
        marginTop: '0px',
        marginBottom: '45px',
        padding: '0 15px',
        '& > *': {
          width: '100% !important',
          maxWidth: '100% !important'
        }
      }
    })
  ),

  SecondSection: styled('section')({
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    width: '1200px',
    margin: '0 auto',
    marginTop: '-15px'
  }),

  ThirdSection: styled('section')(({ theme }) => ({
    maxWidth: '100%',
    width: '1200px',
    margin: '0 auto',
    backgroundColor: 'white',
    borderRadius: '2px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      borderRadius: '25px',
      padding: '50px -10px'
    }
  })),

  FourthSection: styled('section')({
    maxWidth: '100%',
    width: '1200px',
    margin: '-10px auto',
    backgroundColor: 'white',
    padding: '0 5px',
    borderRadius: '2px',
    paddingBottom: '25px'
  }),

  MainContainer: styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: '20px'
  }),

  PropertyGrid: styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(300px, 1fr))',
    justifyItems: 'stretch',
    alignItems: 'stretch', // garante que os itens estiquem na altura
    gap: '10px',
    width: '100%',
    marginTop: '5px',
    padding: '10px',
    '& > *': { height: '100%' }, // o filho direto (Link) ocupa 100%
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '5px',
      padding: '0 5px'
    }
  })),

  PropertyContainer: styled('div')({
    display: 'flex',
    maxWidth: '1330px',
    alignItems: 'flex-start',
    height: '100%',
    margin: '0 auto',
    borderRadius: '10px',
    padding: '20px',
    backgroundColor: 'white',
    flexDirection: 'column'
  }),

  Body: styled('div')({
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100%'
  }),

  Pagination: styled('div')(({ theme }) => ({
    maxWidth: '100%',
    width: '1200px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    margin: '0 auto',
    padding: '10px',
    paddingRight: 0,
    paddingBottom: '25px',
    // flexWrap: 'wrap',

    button: {
      padding: '8px 16px',
      cursor: 'pointer',
      color: 'white',
      border: '1px solid #ddd',
      backgroundColor: '#2C62C7',
      borderRadius: '5px',
      minWidth: '40px',
      '&.active': {
        backgroundColor: '#0B327A',
        color: 'white'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: '#2C62C7',
        color: 'white'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '6px 12px',
        fontSize: '14px',
        margin: '2px'
      }
    }
  }))
};
